<template>
  <div v-if="showTerms == true" class="terms_body">
    <div class="login_common term">
      <div v-if="termsType === 0">
        <div class="nav_top">
          <div class="flex_center">
            <div class="btn_back flex_center" @click="closePopup">
              <img class="icon-normal" src="@/assets/icon/icon_back.png"/>
            </div>
            <p class="title">{{termsTitle}}</p>
          </div>
        </div>
        <div class="section">
          <div class="popup_tab_contents_item">
            <p class="pop_tab_contents" v-html="terms">
              {{ terms }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="termsType === 1">
        <div class="nav_top">
          <div class="flex_center">
            <div class="btn_back flex_center" @click="closePopup">
              <img class="icon-normal" src="@/assets/icon/icon_back.png"/>
            </div>
            <p class="title">{{privacyTitle}}</p>
          </div>
        </div>
        <div class="section">
          <div class="popup_tab_contents_item">
            <p v-html="privacy">
              {{ privacy }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavTop from '@/components/navTop'

let app = null
export default {
	name: 'terms',
  components: { NavTop },
  props:{
	  show: Boolean,
    type: Number
  },
  data () {
    return {
      beforeScrollY: 0,
      termsTitle: '서비스 이용 약관',
      privacyTitle: '개인정보 취급방침',
      showTerms: this.show,
      termsType: this.type,
      terms: '내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 \n' +
      '이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용서비스 이용 약관 내용\n' +
      '\n' +
      '\n' +
      '\n',
      privacy: '개인정보취급방침 개인정보취급방침 개인정보취급방침 \n' +
      '개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침 개인정보취급방침\n' +
      '\n' +
      '\n' +
      '\n'
    }
  },
  created () {
    app = this
  },
  watch: {
    show: function (value) {
      this.showTerms = value

      if (value) {
        this.beforeScrollY = window.scrollY
        window.scrollTo(0, 0)
      } else {
        window.scrollTo(0, this.beforeScrollY)
        this.beforeScrollY = 0
      }
    },
    type: function (value) {
      this.termsType = value
    }
  },
  methods:{
    closePopup () {
      this.showTerms = false
      this.$emit('update:show', false)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.terms_body { position: absolute; top: 0; left: 0; background-color: #ffffff; width: 100%; height: 100%; z-index: 400; box-sizing: initial;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

</style>



// WEBPACK FOOTER //
// src/components/terms.vue